const FORM_KEY = /* @__PURE__ */ Symbol("FORM_KEY");
export {
  FORM_KEY
};
//# sourceMappingURL=type.js.map
